// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__llda-","navBtn":"sidebar_navBtn__gaXmb"};